import React from "react";

interface NoDataAvailableProps {
  componentName?: string;
  /** Opt-in light surface for the Content module; every other caller stays dark. */
  light?: boolean;
}

const NoDataMessage: React.FC<NoDataAvailableProps> = ({
  componentName,
  light,
}) => {
  return (
    <div
      className={`card text-center align-content-center${
        light ? "" : " bg-dark"
      }`}
    >
      <div className="card-body">
        <div style={light ? undefined : { color: "white" }}>
          No {componentName && `${componentName} `}data available
        </div>
      </div>
    </div>
  );
};

export default NoDataMessage;
